@let p = promo();
@if (p) {
    <div id="promoCatalogue" class="promo-catalogue" data-testid="home_promo">
        <div class="wrapper" (click)="onClick()" [class.clickable]="p.hasItems">
            @if (p.backgroundImageUrl) {
                <div class="background-image" [transcodeImage]="p.backgroundImageUrl"></div>
            }

            <div class="element info">
                <div class="subtitle-row">
                    @if (p.caption) {
                        <div class="subtitle text-shadow font-medium">{{ p.caption }}</div>
                    }
                    @if (showBadge() && badgeVariant() !== BadgeVariant.PromoBig) {
                        <badge
                            [badge]="p.promoBlock?.badge"
                            [circle]="false"
                            [variant]="badgeVariant()"
                            [showAutomaticBadge]="isEpisodeType()"
                            [hasUpcomingEnabled]="true"
                            [availabilityStartTime]="p.promoBlock?.availabilityStartTime"
                            [availabilityEndTime]="null">
                        </badge>
                    }
                    @if (showBadge() && badgeVariant() === BadgeVariant.PromoBig && isAvailabilityStartPassed() === true) {
                        <badge
                            [badge]="p.promoBlock?.badge"
                            [circle]="false"
                            [variant]="BadgeVariant.PromoNormal"
                            [showAutomaticBadge]="isEpisodeType()"
                            [hasUpcomingEnabled]="true"
                            [availabilityStartTime]="p.promoBlock?.availabilityStartTime"
                            [availabilityEndTime]="null">
                        </badge>
                    }
                </div>

                @if (p.name) {
                    <div class="title font-xxlarge font-bold text-shadow" data-testid="home_promo-title">{{ p.name }}</div>
                }
                @if (p.description) {
                    <div class="description font-light text-shadow font-medium" data-testid="home_promo-description">{{ p.description }}</div>
                }

                @if (showBadge() && badgeVariant() === BadgeVariant.PromoBig && isAvailabilityStartPassed() !== true) {
                    <badge
                        [badge]="null"
                        [circle]="false"
                        [variant]="badgeVariant()"
                        [showAutomaticBadge]="isEpisodeType()"
                        [hasUpcomingEnabled]="true"
                        [availabilityStartTime]="p.promoBlock?.availabilityStartTime"
                        [availabilityEndTime]="null"
                        (availabilityStartPassed)="onAvailabilityStartPassed($event)">
                    </badge>
                }

                @if (showPromoButton()) {
                    <button class="button button-sm secondary" data-testid="home_promo-cta">
                        {{ 'promo.button.review' | transloco }}
                        <img class="ms-3" [src]="skinning.getImage('arrow_primary')" alt="">
                    </button>
                }
            </div>

            @if (p.imageUrl) {
                <div class="element image">
                    <div class="image br-tile" data-testid="home_promo-image"
                         [class]="imageFormat() + (promoFrontOutlineVisible() ? ' outline' : '')"
                         [transcodeImage]="p.imageUrl">
                    </div>
                </div>
            }
        </div>
    </div>
}
